
const FETCH_POLICY="FETCH_POLICY_";
const FETCH_XQTS="FETCH_XQTS";
const FETCH_POLICY_TYPE="FETCH_POLICY_TYPE";
const FETCH_RDPH="FETCH_RDPH";  
const FETCH_ZXZX="FETCH_ZXZX";
const FETCH_XQTS_NEWS="FETCH_XQTS_NEWS";
const FETCH_XQTS_NEWS_DETAIL="FETCH_XQTS_NEWS_DETAIL";

const ActionType={
    FETCH_XQTS,
    FETCH_POLICY,
    FETCH_POLICY_TYPE,
    FETCH_RDPH,
    FETCH_ZXZX,
    FETCH_XQTS_NEWS,
    FETCH_XQTS_NEWS_DETAIL,
}

export default ActionType;